import { Layout} from 'antd';
import { FC, useState, useEffect } from 'react';
import { CustomHeader } from './CustomHeader';
import { PreHeader } from './PreHeader';
import { MenuMobile } from './MenuMobile';
import { IMenu } from '../../model/IMenu';
import { IPreHeader } from '../../model/IPreHeader';


const { Content } = Layout;

const AppShell: FC<{menu:IMenu}> = (props) => {

  const [preHeader, setPreheader] = useState<IPreHeader>()


  useEffect(() => {
      fetch(`${process.env.REACT_APP_URL_BLOB}/config/data/preheader.json`)
        .then((response) => response.json())
        .then((_preHeader) => {
          setPreheader(_preHeader); 
        });
    }, []);




  const [open, setOpen] = useState(false);
  const showDrawer = (isOpen: boolean) => {
    setOpen(!isOpen);
  };

  const handleStyle = (mfPage: string) => {
    if (mfPage === "derco-mf-home") {
      return { marginTop: "-17px" }
    } else {
      return { }
    }
  }

  return (
    <>
 
        <PreHeader preHeader={preHeader as IPreHeader}></PreHeader>
        <Layout className='Layout'>
        <CustomHeader  menu={props.menu} open={open} showDrawer={showDrawer}></CustomHeader>
        <MenuMobile preHeader={preHeader as IPreHeader} open={open} showDrawer={showDrawer}></MenuMobile>

        <Content style={{paddingTop:"12px"}}>
          <div className="site-layout-content" >
            {
              props.menu.items.map((_, index) => (
                <div key={index} id={`single-spa-application:${_.spaName}`} style={handleStyle(_.spaName)}></div>
              ))
            }
          </div>
        </Content>
      </Layout>
    </>

  )
};

export default AppShell